<script lang="ts" setup>
import type { PropType } from 'vue';
import { useChatStore } from '../stores/chatStore';

const chatStore = useChatStore();

const props = defineProps({
    suggestions: {
        type: Array as PropType<{ question: string; keywords: string[] }[]>,
        required: true,
    },
    reason: {
        type: String,
        default: '',
    },
    language: {
        type: String,
        required: true,
    },
    promptText: {
        type: String,
        default: '以下の中からお探しの情報をお選びください',
    },
});

const selectSuggestion = (question: string) => {
    chatStore.search(question, null, { keepDeepResearchPanel: false });
};
</script>

<template>
    <div class="intent-wrapper">
        <div class="intent-bubble">
            <div class="intent-bubble__body">
                <p class="intent-title">{{ props.promptText }}</p>
                <p v-if="props.reason" class="intent-reason">{{ props.reason }}</p>
                <div class="intent-options">
                    <button v-for="(suggestion, index) in props.suggestions" :key="index" class="intent-option"
                        @click="selectSuggestion(suggestion.question)">
                        {{ suggestion.question }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.intent-wrapper {
    padding: 0 2.9rem;
}

.intent-bubble {
    position: relative;
    background-color: #ffffff;
    border: 2px solid #ffffff;
    border-radius: 5px;
    padding: 15px;
    box-shadow: 0 4px 3px rgba(0, 0, 0, 0.07), 0 2px 2px rgba(0, 0, 0, 0.06);
}

.intent-bubble::after {
    content: '';
    position: absolute;
    top: 10%;
    left: -8px;
    transform: translateY(-10%);
    border-width: 8px 8px 8px 0;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
    display: block;
    width: 0;
}

.intent-bubble::before {
    content: '';
    position: absolute;
    top: 10%;
    left: -10px;
    transform: translateY(-10%);
    border-width: 10px 10px 10px 0;
    border-style: solid;
    border-color: transparent #ffffff transparent transparent;
    display: block;
    width: 0;
}

.intent-bubble__body {
    position: relative;
    background: #ffffff;
    border-radius: 8px;
    z-index: 2;
}

.intent-title {
    margin: 0 0 12px;
    font-size: 1.05rem;
    line-height: 1.5;
    font-weight: 600;
    color: #111827;
}

.intent-reason {
    margin: 0 0 14px;
    font-size: 0.9rem;
    line-height: 1.5;
    color: #4b5563;
}

.intent-options {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 12px;
}

.intent-option {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    border-radius: 999px;
    border: 1px solid #d43c3c;
    background: #ffffff;
    color: #d43c3c;
    font-size: 0.95rem;
    line-height: 1.2;
    cursor: pointer;
    transition: all 0.15s ease;
    box-shadow: 0 4px 10px rgba(212, 60, 60, 0.08);
}

.intent-option:hover {
    background: #fff5f5;
    box-shadow: 0 6px 14px rgba(212, 60, 60, 0.12);
}

.intent-option:active {
    transform: translateY(1px);
}
</style>
